import type { QueryClient } from "@tanstack/react-query";
import { createOpenApiConfiguration } from "@/lib/utils";
import { SeasonsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";

export async function prefetchSeasonPublic(
  queryClient: QueryClient,
  seasonId: number,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Seasons, seasonId, "public"],
    queryFn: () => {
      const service = new SeasonsApi(createOpenApiConfiguration());
      return service.getSeasonById({ id: seasonId });
    },
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
